
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"37","fill":"none","viewBox":"0 0 60 37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M21.7 25.8h1.4v5.4h1.8v-5.4h1.4v-1.5h-4.6v1.5zm13.9-1.6l-1.7 7h1.9L36 30h1.4l.2 1.2h2l-1.7-7h-2.3zm.6 4.4l.5-2.9.5 2.9h-1zm8.4 2.4c-.1-.2-.1-.6-.1-1v-.6c0-1-.2-1.5-1.1-1.6.8-.2 1.2-.8 1.2-1.7 0-1.1-.5-1.9-1.9-1.9h-2.8v7h1.8v-2.8h.5c.4 0 .6.2.6 1v.5c0 .3 0 .9.2 1.3h1.8c-.1 0-.2-.1-.2-.2zm-2.5-3.7h-.4v-1.7h.3c.6 0 .8.2.9.9 0 .5-.3.8-.8.8zm-24.6 3.9h1.8v-2.9h2.2v-1.4h-2.2v-1.2h2.3v-1.5h-4.1v7zm-.8-7h-1.8v7h1.8v-7zm14.8-.1c-1.9 0-2.5.9-2.5 3.6s.5 3.6 2.5 3.6c1.2 0 2.3-.4 2.3-2.4v-.5H32c0 1.3-.1 1.7-.5 1.7-.6 0-.6-.5-.6-2.4s0-2.4.6-2.4c.3 0 .5.2.5 1v.4h1.8v-.4c0-1.3-.6-2.2-2.3-2.2zm-17.4-8.5h5.2v-3.3h-5.2V9.5h5.5V6H9.8v16.3h4.3v-6.7zm13.4 6.7l1.7-10.9 1.4 10.9h4.7l2.8-16.2h-4.2l-1.2 11.2L31 6.1h-3.9l-1.6 11.2-1.3-11.2H20l2.8 16.2h4.7zm-16.1 9.1c.6 0 1.3-.2 1.5-.8v.6h1.2v-3.8h-2.3v1.2h.7c0 1.3-.2 1.5-.6 1.5-.6 0-.6-.5-.7-2.3 0-1.9.1-2.4.7-2.4.2 0 .3.1.4.3.1.2.1.4.1.8h1.8c0-1.7-.9-2.3-2.2-2.3-2.2 0-2.6 1.3-2.6 3.6s.2 3.6 2 3.6zm36.7-7.2h-2.6v7h2.6c2.1 0 2.2-1.7 2.2-3.5s-.1-3.5-2.2-3.5zm-.4 5.8h-.4v-4.4h.3c.7 0 .8.3.9 2.2 0 1.9-.1 2.2-.8 2.2zm-4-7.4c1.5 0 3-.4 3.6-1.8l.1 1.4h2.9v-8.8h-5.6v2.9h1.5c-.1 2.8-.6 3.4-1.5 3.4-1.4 0-1.6-1.1-1.6-5.5s.2-5.6 1.6-5.6c.5 0 .8.2 1 .7.1.4.2 1.1.2 1.9h4.2c0-4-2.1-5.5-5.2-5.5-5.1 0-6.1 3-6 8.5 0 5.3.4 8.4 4.8 8.4z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M57.3 37H2.5C1.1 37 0 35.9 0 34.6V2.4C0 1.1 1.1 0 2.5 0h54.7c1.4 0 2.5 1 2.6 2.4v32.2c0 1.3-1.1 2.4-2.5 2.4zM2.5 1C1.7 1 1 1.7 1 2.4v32.2c0 .8.6 1.4 1.5 1.4h54.8c.8 0 1.5-.7 1.5-1.4V2.4c-.1-.8-.7-1.4-1.6-1.4H2.5z"}})])
          )
        }
      }
    